const actions = {
  SET_STATE: 'activity/SET_STATE',
  GET_ZERO_ACTIVITY_REQUEST: 'activity/GET_ZERO_ACTIVITY_REQUEST',
  DELETE_ZERO_ACTIVITY: 'activity/DELETE_ZERO_ACTIVITY',
}

export default actions
